import { useMemo } from 'react';
import { collection, query, where } from 'firebase/firestore';
import { db } from '../firebase';
import { useFirestoreQuery } from './useFirestoreQuery';

/**
 * Live company roster from `users` where `companyId` matches.
 * @param {string | null | undefined} companyId
 * @param {{ enabled?: boolean }} [options]
 */
export function useCompanyUsers(companyId, options = {}) {
  const enabled = options.enabled !== false && Boolean(companyId);

  const usersQuery = useMemo(() => {
    if (!companyId) return null;
    return query(collection(db, 'users'), where('companyId', '==', companyId));
  }, [companyId]);

  const { data, loading, error } = useFirestoreQuery(usersQuery, { enabled });

  const users = useMemo(() => {
    const rows = data.map((row) => ({
      uid: row.uid || row.id,
      ...row,
    }));
    rows.sort((a, b) =>
      (a.displayName || a.email || '').localeCompare(b.displayName || b.email || ''),
    );
    return rows;
  }, [data]);

  return { users, loading, error };
}
